// RUSSIA
export const locale = {
    TRANSLATOR: {
        SELECT: "Выберите язык"
    },
    MENU: {
        NEW: "новый",
        ACTIONS: "Действия",
        CREATE_POST: "Добавить запись",
        PAGES: "Страницы",
        FEATURES: "Features",
        APPS: "Приложения",
        DASHBOARD: "Главная"
    },
    AUTH: {
        GENERAL: {
            OR: "Или",
            SUBMIT_BUTTON: "Войти",
            NO_ACCOUNT: "У Вас нет учетной записи?",
            SIGNUP_BUTTON: "Регистрация",
            FORGOT_BUTTON: "Забыли пароль",
            BACK_BUTTON: "Назад",
            PRIVACY: "Privacy",
            LEGAL: "Legal",
            CONTACT: "Контакт"
        },
        LOGIN: {
            TITLE: "Логин",
            BUTTON: "Войти в систему"
        },
        FORGOT: {
            TITLE: "Забыли пароль?",
            DESC: "Введите ваш e-mail и сбросьте пароль",
            SUCCESS: "Ваша учетная запись была успешно сброшена."
        },
        REGISTER: {
            TITLE: "Регистрация",
            DESC: "Для регистрации введите Ваши данные",
            SUCCESS: "Ваша учетная запись успешно создана."
        },
        INPUT: {
            EMAIL: "Email",
            FULLNAME: "Ваше полное имя",
            PASSWORD: "Пароль",
            CONFIRM_PASSWORD: "Подтверждение пароля",
            USERNAME: "Пользователь"
        },
        VALIDATION: {
            INVALID: "{{name}} не верно",
            REQUIRED: "Введите {{name}}",
            MIN_LENGTH: "Минимальное количество символов для {{name}} {{min}}",
            AGREEMENT_REQUIRED: "Примите условия соглашения",
            NOT_FOUND: "Пользователь {{name}} не найден",
            INVALID_LOGIN: "Неверный логин и/или пароль.",
            REQUIRED_FIELD: "Обязательно поле",
            MIN_LENGTH_FIELD: "Минимальное количество символов:",
            MAX_LENGTH_FIELD: "Максимальное количество символов:",
            INVALID_FIELD: "Неверное поле"
        }
    },
    ECOMMERCE: {
        COMMON: {
            SELECTED_RECORDS_COUNT: "Selected records count: ",
            ALL: "All",
            SUSPENDED: "Suspended",
            ACTIVE: "Active",
            FILTER: "Filter",
            BY_STATUS: "by Status",
            BY_TYPE: "by Type",
            BUSINESS: "Business",
            INDIVIDUAL: "Individual",
            SEARCH: "Search",
            IN_ALL_FIELDS: "in all fields"
        },
        ECOMMERCE: "eCommerce",
        CUSTOMERS: {
            CUSTOMERS: "Customers",
            CUSTOMERS_LIST: "Customers list",
            NEW_CUSTOMER: "New Customer",
            DELETE_CUSTOMER_SIMPLE: {
                TITLE: "Customer Delete",
                DESCRIPTION: "Are you sure to permanently delete this customer?",
                WAIT_DESCRIPTION: "Customer is deleting...",
                MESSAGE: "Customer has been deleted"
            },
            DELETE_CUSTOMER_MULTY: {
                TITLE: "Customers Delete",
                DESCRIPTION: "Are you sure to permanently delete selected customers?",
                WAIT_DESCRIPTION: "Customers are deleting...",
                MESSAGE: "Selected customers have been deleted"
            },
            UPDATE_STATUS: {
                TITLE: "Status has been updated for selected customers",
                MESSAGE: "Selected customers status have successfully been updated"
            },
            EDIT: {
                UPDATE_MESSAGE: "Customer has been updated",
                ADD_MESSAGE: "Customer has been created"
            }
        }
    }
};
